import axios, { AxiosResponse } from 'axios';
import { LoginAuth, UserModel } from './_models';
import { ResponseApi } from 'types';

export type UsersQueryResponse = ResponseApi<any>;
export async function getUserByToken(token: string): Promise<UsersQueryResponse> {
  return axios
    .get('account/api/auth/validate_token/')
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data);
}

export async function login(
  values: LoginAuth,
): Promise<ResponseApi<{ user: UserModel; token: string }>> {
  return axios
    .post('/account/api/auth/login', values)
    .then((d: AxiosResponse<ResponseApi<{ user: UserModel; token: string }>>) => d.data);
}
